import { NotificationGroup, NotificationPreferences, UserInfo, UserPreferences } from "../../reducers/states/user-info";
import { types } from "../types";

export const loadUserInfoAndPreferences = () => ({
  type: types.GET_CURRENT_USER_INFO_AND_PREFERENCES,
});

// Get Current User Info
export const getCurrentUserInfoRequest = () => ({
  type: types.GET_CURRENT_USER_INFO,
  payload: {},
});
export const getCurrentUserInfoSuccess = (userInfo: UserInfo) => ({
  type: types.GET_CURRENT_USER_INFO_SUCCESS,
  payload: { userInfo },
});
export const getCurrentUserInfoFailure = (failureMessage: string) => ({
  type: types.GET_CURRENT_USER_INFO_FAILURE,
  payload: { failureMessage },
});

// Get User Info Request - for displaying names in the app
export interface getUserInfoPayload {
  email: string;
}
export const getUserInfoRequest = (email: string) => ({
  type: types.GET_USER_INFO,
  payload: { email } as getUserInfoPayload,
});
export const getUserInfoSuccess = (userInfo: UserInfo) => ({
  type: types.GET_USER_INFO_SUCCESS,
  payload: { userInfo },
});
export const getUserInfoFailure = (failureMessage: string) => ({
  type: types.GET_USER_INFO_FAILURE,
  payload: { failureMessage },
});

// Get all Notification Groups
export const getAllNotificationGroupsRequest = () => ({
  type: types.GET_ALL_NOTIFICATION_GROUPS,
  payload: {},
});
export const getAllNotificationGroupsSuccess = (notifGroups: NotificationGroup[]) => ({
  type: types.GET_ALL_NOTIFICATION_GROUPS_SUCCESS,
  payload: { notifGroups },
});
export const getAllNotificationGroupsFailure = (failureMessage: string) => ({
  type: types.GET_ALL_NOTIFICATION_GROUPS_FAILURE,
  payload: { failureMessage },
});

export interface getUserNotificationPrefsPayload {
  email: string;
}

// Get a User's Notification Preferences
export const getUserNotificationPrefsRequest = (email: string) => ({
  type: types.GET_USER_NOTIFICATION_PREFS,
  payload: { email } as getUserNotificationPrefsPayload,
});
export const getUserNotificationPrefsSuccess = (userNotifPrefs: NotificationPreferences) => ({
  type: types.GET_USER_NOTIFICATION_PREFS_SUCCESS,
  payload: { userNotifPrefs },
});
export const getUserNotificationPrefsFailure = (failureMessage: string) => ({
  type: types.GET_USER_NOTIFICATION_PREFS_FAILURE,
  payload: { failureMessage },
});

// Update User Notification Preferences
export interface updateUserNotificationPrefsPayload {
  groupIds?: number[];
  email: string;
  phoneNumber?: string;
  isTextable?: boolean;
}

export const updateUserNotificationGroupsRequest = (email: string, groupIds: number[]) => ({
  type: types.UPDATE_USER_NOTIFICATION_PREFS,
  payload: { email, groupIds } as updateUserNotificationPrefsPayload,
});

export const updateUserNotificationPrefsRequest = (email: string, groupIds: number[], isTextable: boolean) => ({
  type: types.UPDATE_USER_NOTIFICATION_PREFS,
  payload: { email, groupIds, isTextable } as updateUserNotificationPrefsPayload,
});

export const updateUserPhoneRequest = (email: string, phoneNumber: string) => ({
  type: types.UPDATE_USER_NOTIFICATION_PREFS,
  payload: { email, phoneNumber } as updateUserNotificationPrefsPayload,
});

export const updateUserNotificationPrefsSuccess = (successMessage: string) => ({
  type: types.UPDATE_USER_NOTIFICATION_PREFS_SUCCESS,
  payload: { successMessage },
});

export const updateUserNotificationPrefsFailure = (failureMessage: string) => ({
  type: types.UPDATE_USER_NOTIFICATION_PREFS_FAILURE,
  payload: { failureMessage },
});

// Get User Preferences
export const getUserPreferencesRequest = () => ({
  type: types.GET_USER_PREFERENCES,
  payload: {},
});
export const getUserPreferencesSuccess = (userPreferences: UserPreferences) => ({
  type: types.GET_USER_PREFERENCES_SUCCESS,
  payload: { userPreferences },
});
export const getUserPreferencesFailure = (failureMessage: string) => ({
  type: types.GET_USER_PREFERENCES_FAILURE,
  payload: { failureMessage },
});

// Update User Preferences
export interface updateUserPreferencesPayload {
  userPreferences: UserPreferences;
  userEmail?: string
}
export const updateUserPreferencesRequest = (
  userPreferences: UserPreferences,
  userEmail?: string,
) => ({
  type: types.UPDATE_USER_PREFERENCES,
  payload: {
    userPreferences,
    ...(userEmail && { userEmail }),
  } as updateUserPreferencesPayload,
});
export const updateUserPreferencesSuccess = (successMessage: string) => ({
  type: types.UPDATE_USER_PREFERENCES_SUCCESS,
  payload: { successMessage },
});
export const updateUserPreferencesFailure = (failureMessage: string) => ({
  type: types.UPDATE_USER_PREFERENCES_FAILURE,
  payload: { failureMessage },
});
